import clsx from "classnames";
import classes from "./styles.module.scss";
import DiscoverScroll from "@/components/DiscoverScroll";
import Body from "@/ui/Body";
import Button from "@/components/Button";
import Image from "@/ui/Image";
import { useState } from "react";
import Title from "@/ui/Title";

export const Hero = ({ label, body, moreBody, highlight, content, className, cta, image, scroll = true }) => {
  const [showAll, setShowAll] = useState(false);

  function toggleShow() {
    setShowAll(!showAll);
  }

  return (
    <div className={clsx(className, "hero-section", classes.hero2)}>
      <div className={classes.left_section}>
        <div className={classes.title}>
          <div className={classes.highlight}>
            <Title tag="h1" title={highlight || label} variant="primary" highlight="true" />
          </div>
          {/* {image ? <Image className={classes.image} img={image} alt={label} size="500x280" /> : <></>} */}
        </div>
        {(content || body) && (
          <div className={classes.contentCont}>
            <div className={classes.content}>{content}</div>
            <Body body={body} />
            {showAll ? <Body body={moreBody} /> : <></>}
            {moreBody && (
              <div className={classes.readMore} onClick={() => toggleShow()}>
                {showAll ? "Show Less -" : "Read More +"}
              </div>
            )}
            <div className={classes.ctas}>
              {Array.isArray(cta) &&
                cta.map((c, i) => (
                  <Button
                    key={`${c.button_text}-${i}`}
                    display={c.button_text}
                    variant={c.variant}
                    animation={c.animation}
                    link={c.link}
                    newTab={c.new_tab}
                    className={`font-regular btn-${c.variant} cta button ${c.variant} ${c.new_tab} ${c.animation}`}
                  ></Button>
                ))}
            </div>
          </div>
        )}
      </div>
      {scroll && (
        <div className={classes.right_section}>
          <DiscoverScroll />
        </div>
      )}
    </div>
  );
};

export default Hero;
